import { Config } from 'config/envConfig';
import React, { useState } from 'react';
import axios from 'axios';
import { getDate, getTime } from '@quyva/common';
import { getUrl } from '../../../utils';
import {
    faFile,
    faFileExcel,
    faFileImage,
    faFileLines,
    faFilePdf,
    faFileWord,
} from '@fortawesome/free-solid-svg-icons';
import { Button } from '@quyva/shared-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const QuestionContentView = ({ chatObject, encodedToken }) => {
    const attachments =
        Array.isArray(chatObject?.attachments) &&
        chatObject.attachments.length > 0
            ? chatObject.attachments
            : [];

    const [loadingPath, setLoadingPath] = useState(null);

    const handleDownload = async (filePath) => {
        if (!filePath) return;
        setLoadingPath(filePath);

        try {
            const encodedPath = encodeURIComponent(filePath);

            // 👇 same pattern you used for dashboard/import
            const dynamicUrl = getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/attachments/download?path=${encodedPath}`
            );

            const response = await axios.get(dynamicUrl, {
                responseType: 'blob',
                headers: {
                    Authorization: encodedToken,
                },
                timeout: 120000,
            });

            // Create and trigger the download
            const blob = response.data;
            const filename = filePath.split(/[/\\]/).pop() || 'download';
            const blobUrl = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            // Try to extract a helpful message from server if possible
            let message = 'Download failed';
            if (err.response && err.response.data) {
                try {
                    // axios returns blob for non-2xx too; attempt to read as text
                    const text = await err.response.data.text();
                    if (text) message = text;
                } catch (e) {
                    // ignore
                }
            } else if (err.message) {
                message = err.message;
            }

            // Replace this alert with your app's toast/snackbar if available
            alert(
                `${message} ${
                    err.response?.status ? `(${err.response.status})` : ''
                }`
            );
            console.error('Download error:', err);
        } finally {
            setLoadingPath(null);
        }
    };

    return (
        <>
            <div className='text-slate-700'>{chatObject.question}</div>

            {attachments.length > 0 && (
                <div className='mt-3'>
                    {/* <div className='text-sm font-medium text-texts-secondary300 mb-1'>
                        Attachments:
                    </div> */}

                    <div className='mt-3 flex flex-wrap gap-2'>
                        {attachments.map((filePath, idx) => {
                            const fileName =
                                typeof filePath === 'string'
                                    ? filePath.split(/[/\\]/).pop()
                                    : `file-${idx + 1}`;

                            const ext = fileName
                                .split('.')
                                .pop()
                                ?.toLowerCase();
                            const isLoading = loadingPath === filePath;

                            const fileIcons = {
                                pdf: faFilePdf,
                                doc: faFileWord,
                                docx: faFileWord,
                                xls: faFileExcel,
                                xlsx: faFileExcel,
                                png: faFileImage,
                                jpg: faFileImage,
                                jpeg: faFileImage,
                                txt: faFileLines,
                            };

                            const icon = fileIcons[ext] || faFile;

                            return (
                                <Button
                                    key={idx}
                                    onClick={() => handleDownload(filePath)}
                                    disabled={isLoading}
                                    type='info'
                                    className='
                    !bg-backgrounds-secondaryChat
                    !border-borders-secondary200
                    min-w-[150px] max-w-[180px]
                    h-[46px]                      /* smaller height */
                    flex items-center gap-2
                    shadow-inner
                    hover:scale-105
                    transition
                    overflow-hidden
                '
                                    text={
                                        <div
                                            className='flex items-center gap-2 w-full'
                                            title={
                                                fileName
                                            } /* full filename on hover */
                                        >
                                            <FontAwesomeIcon
                                                icon={icon}
                                                className='text-texts-primary400 text-sm'
                                            />

                                            <div className='flex flex-col flex-1 leading-tight overflow-hidden'>
                                                {/* filename */}
                                                <span
                                                    className='font-semibold text-sm text-texts-primary400 truncate block'
                                                    style={{
                                                        maxWidth: '110px',
                                                    }}
                                                >
                                                    {fileName}
                                                </span>

                                                {/* subtext */}
                                                <span className='text-[10px] text-texts-secondary300 truncate'>
                                                    {isLoading
                                                        ? 'Downloading…'
                                                        : 'Click to download'}
                                                </span>
                                            </div>
                                        </div>
                                    }
                                />
                            );
                        })}
                    </div>
                </div>
            )}

            <div className='flex justify-between items-between text-xs mt-2 text-texts-secondary300'>
                <div>{getDate(chatObject.timestamp)}</div>
                <div>{getTime(chatObject.timestamp)}</div>
            </div>
        </>
    );
};
